import { isFuture } from "date-fns";
import type { RuleHandler } from "../types";

const checkExpired: RuleHandler = (context) => {
  const expiresAt = context.allocation.expiresAt.toDate();

  // if the token is expiring soon via TTL thats enough regardless of the date
  return context.allocation.markedForDeletion ? false : isFuture(expiresAt);
};

export { checkExpired };
